import React, { createContext } from 'react';
import type { DataInputConfig } from '@/types/automationFields';

export type IconMap = Map<string, React.ReactNode>; // key = option value string (e.g., "static <id>")

export type DataInputIconsContextType = {
  iconsByOptionValue: IconMap;
  getIconForOptionValue: (value: string) => React.ReactNode | null;
  getIconForConfig: (config: DataInputConfig) => React.ReactNode | null;
  isLoading: boolean;
};

export const DataInputIconsContext = createContext<DataInputIconsContextType | null>(null);
